













import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import EditableListItem from '@/components/atoms/EditableListItem.vue';
import { IMenu, MenuType, EditActionEvent } from '@/types/type';

@Component({
  components: { EditableListItem },
})
export default class SortList extends Vue {
  @Prop()
  private editable!: boolean;
  @Prop()
  private items!: IMenu[];

  @Emit('edit-list-action')
  private editListAction(
    event: EditActionEvent,
    index: number
  ): EditActionEvent {
    return { ...event, index, change: true };
  }
}
